import {
  GET_ALL_ADS_LANDING,
  ADS_LANDING_GET_ERROR,
  GET_ADS_LANDING_REQUEST,
  ADD_ADS_LANDING_ERROR,
  ADD_ADS_LANDING,
  GET_ADS_LANDING_BY_ID,
  DELETE_ADS_LANDING_ERROR,
  DELETE_ADS_LANDING_BY_ID,
  UPDATE_ADS_LANDING_ERROR,
  UPDATE_ADS_LANDING_BY_ID,
} from "../../constant";

const initialState = {
  adsLanding: { list: [], pagination: {} },
  selected: null,
  loading: false,
  error: false,
};

const AdsLandingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADS_LANDING_REQUEST:
      return { ...state, loading: true };
    case GET_ALL_ADS_LANDING:
      return {
        ...state,
        adsLanding: action.data || { list: [], pagination: {} },
        loading: false,
        error: false,
      };
    case ADS_LANDING_GET_ERROR:
      return { ...state, error: true, loading: false };
    case ADD_ADS_LANDING:
      return { ...state, loading: false, error: false };
    case ADD_ADS_LANDING_ERROR:
      return { ...state, loading: false, error: true };
    case GET_ADS_LANDING_BY_ID:
      return { ...state, selected: action.data, loading: false };
    case DELETE_ADS_LANDING_BY_ID:
      return { ...state, loading: false };
    case DELETE_ADS_LANDING_ERROR:
    case UPDATE_ADS_LANDING_ERROR:
      return { ...state, loading: false, error: true };
    case UPDATE_ADS_LANDING_BY_ID:
      return { ...state, loading: false, error: false };
    default:
      return state;
  }
};

export default AdsLandingReducer;
